import type { ProductsRequestParamsType } from '@Store/types/index'

export default (
  queryParams: URLSearchParams,
  generatedValues: Partial<ProductsRequestParamsType> & any,
): Partial<ProductsRequestParamsType> => {
  const newValues = { ...generatedValues }
  if (queryParams.has('price_min')) {
    newValues.price_min = Number(
      queryParams.get('price_min')?.replaceAll(',', '.'),
    )
  }

  if (queryParams.has('price_max')) {
    newValues.price_max = Number(
      queryParams.get('price_max')?.replaceAll(',', '.'),
    )
  }

  if (queryParams.has('index_min')) {
    const raw = queryParams.get('index_min')
    const parsed = Number(raw)
    if (raw && !isNaN(parsed)) newValues.index_min = parsed
  }

  if (queryParams.has('index_max')) {
    const raw = queryParams.get('index_max')
    const parsed = Number(raw)
    if (raw && !isNaN(parsed)) newValues.index_max = parsed
  }

  if (queryParams.has('company-filter-operator')) {
    const company_filter_operator = queryParams.get('company-filter-operator')
    if (company_filter_operator) {
      newValues.company_filter_operator = company_filter_operator
      delete newValues['company-filter-operator']
    }
  }

  if (queryParams.has('tag-filter-operator')) {
    const tag_filter_operator = queryParams.get('tag-filter-operator')
    if (tag_filter_operator) {
      newValues.tag_filter_operator = tag_filter_operator
      delete newValues['tag-filter-operator']
    }
  }

  return newValues
}
